<script>export let style = "";</script>

<svg style={style} xmlns="http://www.w3.org/2000/svg" version="1.1" width="24" height="24" viewBox="0 0 987.525 987.525">
	<path fill="currentColor" d="M132.138,855.425c43,43,93.2,76.301,149.3,99.101c54.1,21.899,111.1,33,169.6,33s115.601-11.101,169.601-33
		c56-22.7,106.199-56,149.3-99.101l60.899-60.899l-176.8-176.8l-60.899,60.899c-38,38-88.4,58.9-142.101,58.9
		s-104.2-20.9-142.1-58.9c-78.4-78.399-78.4-205.899,0-284.3l60.899-60.899l-176.8-176.7l-60.9,60.899
		c-43,43-76.3,93.2-99.1,149.301c-21.9,54.1-33,111.1-33,169.6s11.1,115.6,33,169.6C55.738,762.226,89.038,812.425,132.138,855.425z
		"/>
	<path fill="currentColor" d="M878.038,478.625c-23.399-23.399-61.399-23.399-84.899,0l-82.601,82.601l176.8,176.8l82.601-82.601
		c23.399-23.399,23.399-61.399,0-84.899L878.038,478.625z"/>
	<path fill="currentColor" d="M332.139,17.625l-82.601,82.601l176.8,176.8l82.601-82.6c23.399-23.4,23.399-61.4,0-84.9l-91.9-91.9
		C393.538-5.875,355.639-5.875,332.139,17.625z"/>
</svg>
